function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.parse-float.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import ResizeObserver from 'resize-observer-polyfill';
var HIDDENCLASS = 'ka-nav-button--hidden';
var SwiperSlider = /*#__PURE__*/function () {
  /**
   * @constructor
   * @param {String|HTMLElement} prmElement
   * @param {Number} prmScrollWidth
   * @param {Object} options
   */
  function SwiperSlider(prmElement) {
    var prmScrollWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    _classCallCheck(this, SwiperSlider);
    this.swiper = _getSwiper(prmElement);
    this.swiperItem = this.swiper.querySelector('.kl-swiper__slider-item');
    this.buttonsNavigation = this.swiper.querySelectorAll('button.ka-nav-button');
    this.eventLoaded = false;
    this.options = {
      centerWhenNoButtons: true
    };
    Object.assign(this.options, options);
    if (prmScrollWidth !== null) {
      this.scrollWidth = prmScrollWidth;
    } else {
      this.scrollWidth = _getFullWidth(this.swiperItem);
      _getScrollWidthOnResize.call(this);
    }
    _buttonsVisibility.call(this);
  }
  return _createClass(SwiperSlider, [{
    key: "swipe",
    value: function swipe(prmTarget) {
      var swiper = this.swiper.querySelector('.kl-swiper');
      var scrollValue = prmTarget.dataset.controls === 'prev' ? this.scrollWidth * -1 : this.scrollWidth;
      this.showButton(swiper, scrollValue);
      swiper.scrollBy(scrollValue, 0);
    }

    /**
     * @param {HTMLElement} prmScrollSwiper
     * @param {Number} prmScrollValue
     */
  }, {
    key: "showButton",
    value: function showButton(prmScrollSwiper, prmScrollValue) {
      _checkStatusButtons.call(this, prmScrollSwiper, prmScrollValue);
    }
  }]);
}();
/**
 * @param {String|HTMLElement} prmElement
 * @return {HTMLElement}
 */
function _getSwiper(prmElement) {
  if (typeof prmElement === 'string') {
    return document.querySelector("".concat(prmElement));
  }
  return prmElement;
}
function _getScrollWidthOnResize() {
  var _this = this;
  var resizeObserver = new ResizeObserver(function () {
    _this.scrollWidth = _getFullWidth(_this.swiperItem);
    _buttonsVisibility.call(_this);
  });
  resizeObserver.observe(this.swiper);
}

/**
 * @param {HTMLElement} prmElement
 * @return {Number}
 */
function _getFullWidth(prmElement) {
  var style = prmElement.currentStyle || window.getComputedStyle(prmElement);
  var result = prmElement.clientWidth + parseFloat(style.marginLeft) + parseFloat(style.marginRight) + parseFloat(style.paddingLeft) + parseFloat(style.paddingRight) + parseFloat(style.borderLeftWidth) + parseFloat(style.borderRightWidth);
  return result;
}
function _buttonsVisibility() {
  var swiperWidth = this.swiper.querySelector('.kl-swiper').offsetWidth;
  var swiperSlider = this.swiper.querySelector('.kl-swiper__slider');
  var swiperSliderWidth = swiperSlider.scrollWidth;
  var buttonsNavigation = this.swiper.querySelector('.kl-swiper__controls');
  var classButtonsHidden = 'kl-swiper__controls--hidden';
  var classSwiperCenter = 'kl-swiper__slider--center';
  if (swiperSliderWidth > swiperWidth) {
    _initDesktopButtons.call(this);
    buttonsNavigation.classList.remove(classButtonsHidden);
    swiperSlider.classList.remove(classSwiperCenter);
  } else {
    buttonsNavigation.classList.add(classButtonsHidden);
    if (this.options.centerWhenNoButtons) {
      swiperSlider.classList.add(classSwiperCenter);
    }
  }
}
function _initDesktopButtons() {
  var _this2 = this;
  if (!this.eventLoaded) {
    _toConsumableArray(this.swiper.querySelectorAll('button.ka-nav-button')).forEach(function (buttonNavigation) {
      buttonNavigation.addEventListener('click', function (event) {
        _this2.swipe(event.target);
      });
    });
    this.eventLoaded = true;
  }
}

/**
 * @param {HTMLElement} prmScrollSwiper
 * @param {Number} prmScrollValue
 */
function _checkStatusButtons(prmScrollSwiper, prmScrollValue) {
  var limit = prmScrollSwiper.scrollWidth - prmScrollSwiper.clientWidth;
  var scrollPosition = prmScrollSwiper.scrollLeft + prmScrollValue + 1;
  scrollPosition > 1 ? this.buttonsNavigation[0].classList.remove(HIDDENCLASS) : this.buttonsNavigation[0].classList.add(HIDDENCLASS);
  scrollPosition >= limit ? this.buttonsNavigation[1].classList.add(HIDDENCLASS) : this.buttonsNavigation[1].classList.remove(HIDDENCLASS);
}
export default SwiperSlider;